import { Action } from '@ngrx/store';
import { OperationResult } from '../../../core/services/sync-up/operation-result';
import { ActionOptionsArgs, PersistableAction } from '../../../core/store/actions/base-actions';
import { SyncUpItem } from './sync-up-item.model';

export const ENTITY = 'syncUpItem';
export const CLEAR = '[SyncUpItem] Clear';
export const CLEAR_ERRORS = '[SyncUpItem] Clear Errors';
export const CREATE = '[SyncUpItem] Create';
export const REMOVE = '[SyncUpItem] Remove';
export const REMOVE_BY_KEY = '[SyncUpItem] Remove By Key';
export const RETRY = '[SyncUpItem] Retry';
export const SET_SYNC_COUNT = '[SyncUpItem] Set Sync Count';
export const SUBMIT = '[SyncUpItem] Submit';
export const UPDATE = '[SyncUpItem] Update';
export const UPDATE_FROM_OPERATION_RESULT = '[SyncUpItem] Update from OperationResult';

abstract class BaseAction extends PersistableAction {
    readonly entity = ENTITY;

    constructor(public payload: SyncUpItem, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class CreateAction extends BaseAction {
    readonly type = CREATE;
}

export class RemoveAction extends BaseAction {
    readonly type = REMOVE;
}

export class RemoveByKeyAction implements Action {
    readonly type = REMOVE_BY_KEY;
    constructor(public payload: {key: string}) {

    }
}

export class UpdateAction extends BaseAction {
    readonly type = UPDATE;
}

export class ClearAction implements Action {
    readonly type = CLEAR;

    constructor(public payload: SyncUpItem) {

    }
}

export class ClearErrorsAction implements Action {
    readonly type = CLEAR_ERRORS;
}

export class RetryAction implements Action {
    readonly type = RETRY;

    constructor(public payload: SyncUpItem) {

    }
}

export class SetSyncCountAction implements Action {
    readonly type = SET_SYNC_COUNT;
    constructor(public payload: {count: number}) {
    }
}

export class UpdateFromOperationResultAction implements Action {
    readonly type = UPDATE_FROM_OPERATION_RESULT;

    constructor(public payload: OperationResult) {

    }

}

export type Actions
    = ClearAction
    | ClearErrorsAction
    | CreateAction
    | RemoveAction
    | RetryAction
    | SetSyncCountAction
    | UpdateAction
    | UpdateFromOperationResultAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/sync-up-item/sync-up-item.actions.ts